import {MutableRefObject} from "react";

import {Card} from "@/components/card/Card.tsx";
import {Divider} from "@/components/divider/Divider.tsx";
// @ts-expect-error no ts support yet
import TransactionScriptEditor from "@/legacy/transaction/TransactionScriptEditor.jsx";
import {LegacyURL, ServiceDefinition} from "@/lib/types/checks.ts";
import {MonitoringGroupsArchMapperEntry, MonitoringServer} from "@/lib/types/monitoring.ts";
import {TestRunnerField} from "@/pages/checks/components/form/fields/TestRunnerField.tsx";

import styles from "./CheckTestRunnerForm.module.scss";

interface CheckTestRunnerFormProps {
  service: ServiceDefinition;
  runTestMonitoringServers: MonitoringServer[];
  monitoringGroupsArchMapper: MonitoringGroupsArchMapperEntry[];
  legacyURL: LegacyURL;
  transactionEditorRef: MutableRefObject<TransactionScriptEditor>;
  withContextState?: boolean;
}

export const CheckTestRunnerForm = ({
  service,
  runTestMonitoringServers,
  monitoringGroupsArchMapper,
  legacyURL,
  transactionEditorRef,
  withContextState,
}: CheckTestRunnerFormProps) => {
  return (
    <Card className="p-0" variant="white">
      <div className={styles.top}>
        <div className="pulseTextH3Bold">Run a Test</div>
        <div className="pulseTextBodySmall pulse-color-gray-600 mt-2">
          Validate your configuration by running a test.
        </div>
      </div>
      <Divider />
      <div className={styles.bottom}>
        <TestRunnerField
          hasTxnScript={service.has_transaction_script}
          publicTestEnabled={service.can_run_test_on_public}
          runTestLocations={runTestMonitoringServers}
          service={service}
          monitoringGroupsArchMapper={monitoringGroupsArchMapper}
          runTestURL={legacyURL.runTestURL}
          txnRef={transactionEditorRef}
          withContextState={withContextState}
        />
      </div>
    </Card>
  );
};
